import React, { useState } from 'react';
import { Button, Card, CardBody, Container, Label } from 'reactstrap';
import calender from "../../assets/images/icons/uil_calender.svg";
import PDF from "react-pdf-js";
import PdfViewer from '../GreeetingMaterial/PdfViewer';
import useDeviceDetection from '../../hooks/useDeviceDetection';
import pdf40 from '../../assets/pdf/doc-40.pdf';
import pdf41 from '../../assets/pdf/doc-41.pdf';
import pdf42 from '../../assets/pdf/doc-42.pdf';

const NewsNStoriesComponet = ({newsimage, sourceLink, title, date, description, isPdf = false}) => {
    const [selectedPdf, setSelectedPdf] = useState(null);
    const device = useDeviceDetection();

    const handlePdfClick = (pdfPath) => {
        setSelectedPdf(pdfPath);
    };

    const is2025PdfNewsItem = newsimage && newsimage.includes("26Dec2025F.PNG");
    const is2026PdfNewsItem = newsimage && newsimage.toLowerCase().includes("singforhearts.");
    const isMintPdfNewsItem = newsimage && newsimage.toLowerCase().includes("mintpaper.");
    const isPdfNewsItem = is2025PdfNewsItem || is2026PdfNewsItem || isMintPdfNewsItem;
    const pdfFile = isMintPdfNewsItem
        ? pdf42
        : is2026PdfNewsItem
            ? pdf41
            : is2025PdfNewsItem
                ? pdf40
                : null;

    return (
        <div className="h-100">
            <Card className="card-shadow h-100" style={{ display: "flex", flexDirection: "column" }}>
                <div className="">
                    <a className="img-news">
                        <img className="card-img-top" src={newsimage} alt={newsimage} />
                    </a>
                </div>
                <CardBody className="news-card flex-grow-1 d-flex flex-column">
                    
                    <div className="flex-grow-1">
                        <Label className="date-lable" style={{ textTransform: 'uppercase' }}>
                            <img src={calender} width={"20px"} />&nbsp;&nbsp;
                            <span style={{ paddingTop: '20px' }}>{date}</span>
                        </Label>
                        <br />
                        <Label className="news-title" style={{overflowWrap:'anywhere'}}>
                            {title.split(' ').slice(0, 14).join(' ')}
                            {title.split(' ').length > 14 ? '...' : ''}
                        </Label>
                        <Label className="news-content" style={{whiteSpace:'pre-wrap',}}>
                            {description.split(' ').slice(0, 25).join(' ')}
                            {description.split(' ').length > 25 ? '...' : ''}
                        </Label>
                    </div>
                </CardBody>
                <div className="px-3 pb-3">
                    {isPdfNewsItem ? (
                        <Button onClick={() => handlePdfClick(pdfFile)} className='btn-basic-org mb-3 font-15 pl-5'>Details</Button>
                    ) : (
                        <Button href={sourceLink} target="_blank" className='btn-basic-org mb-3 font-15 pl-5'>Details</Button>
                    )}
                </div>
            </Card>
            <PdfViewer pdf={selectedPdf} onCancel={() => setSelectedPdf(null)} visible={!!selectedPdf} />
        </div>
    );
}

export default NewsNStoriesComponet;
